import { useState, useEffect } from "react";
import useAuthStore from "../../../store/authStore";
import { getAllNotes } from "../../../api/notes/getAll";
import "./LinkExistingNoteModal.scss";

function LinkExistingNoteModal({ onSelect, onClose }) {
  const [noteGroups, setNoteGroups] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [searchQuery, setSearchQuery] = useState("");
  const currentProject = useAuthStore((state) => state.currentProject);

  useEffect(() => {
    if (currentProject?._id) {
      setIsLoading(true);
      getAllNotes(false, currentProject._id)
        .then((data) => {
          setNoteGroups(data || []);
          setIsLoading(false);
        })
        .catch((err) => {
          console.error("Error fetching notes:", err);
          setNoteGroups([]);
          setIsLoading(false);
        });
    }
  }, [currentProject?._id]);

  // Filter notes based on search query
  const filteredNoteGroups = noteGroups
    .map((group) => ({
      ...group,
      notes: group.notes?.filter((note) =>
        note.title.toLowerCase().includes(searchQuery.toLowerCase()),
      ),
    }))
    .filter((group) => group.notes?.length > 0);

  const handleNoteClick = (note, group) => {
    if (onSelect) {
      onSelect(note, group);
    }
    onClose();
  };

  return (
    <div className="link-existing-note-modal">
      <div className="search-container">
        <input
          type="text"
          className="search-input"
          placeholder="Search notes..."
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          autoFocus
        />
        <span className="material-symbols-outlined search-icon">search</span>
      </div>

      <div className="notes-list">
        {isLoading ? (
          <div className="loading-state">Loading notes...</div>
        ) : filteredNoteGroups.length === 0 ? (
          <div className="empty-state">
            {searchQuery
              ? "No notes match your search"
              : "No notes found in this project"}
          </div>
        ) : (
          filteredNoteGroups.map((group) => (
            <div
              key={group._id}
              className="notegroup-wrapper"
              style={{ "--notegroup-color": group.color }}
            >
              <div className="notegroup-header">
                <div className="notegroup-title-container">
                  <span className="material-symbols-outlined collapse-icon">
                    expand_more
                  </span>
                  <span className="notegroup-name">{group.name}</span>
                  <span className="notegroup-count">
                    ({group.notes?.length})
                  </span>
                </div>
              </div>
              <div className="notegroup-container">
                {group.notes?.map((note) => (
                  <div
                    key={note._id}
                    className="note-item"
                    onClick={() => handleNoteClick(note, group)}
                  >
                    <div className="note-info">
                      <span className="note-title">{note.title}</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
}

export default LinkExistingNoteModal;
